export default function messengerSet() {
  //ONCE
  function waitForElementToExist(selector) {
    return new Promise(resolve => {
      waitForIframeToExist('web-messenger-container').then(container => {
        function checkElement() {
          if (container.contentWindow.document.querySelector(selector)) {
            return resolve(container.contentWindow.document.querySelector(selector));
          }

          const observer = new MutationObserver(() => {
            if (container.contentWindow.document.querySelector(selector)) {
              resolve(container.contentWindow.document.querySelector(selector));
              observer.disconnect();
            }
          });

          observer.observe(container.contentWindow.document.body, {
            subtree: true,
            childList: true,
          });
        }

        checkElement();
      });
    });
  }

  function showMessengerSetAfterClick() {
    let rdsn_chat_widget = document.getElementsByClassName("-rdsn-chat-widget");

    if (rdsn_chat_widget.length > 0) {
      rdsn_chat_widget[0].style.display = 'block';
    }
    let chat_widget = document.getElementById("rdsn-chat-widget_icon-list");
    if (chat_widget) {
      chat_widget.classList.remove("-rdsn-chat-widget__icon-list-show");
    }
  }

  let iframePromise = null;

  function waitForIframeToExist(eleId) {
    if (iframePromise) {
      return iframePromise;
    }

    iframePromise = new Promise(resolve => {
      const ele = document.getElementById(eleId);
      if (ele) {
        return resolve(ele);
      }

      const observer = new MutationObserver(() => {
        const ele = document.getElementById(eleId);
        if (ele) {
          resolve(ele);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        subtree: true,
        childList: true,
      });
    });

    return iframePromise;
  }

  const clickEventStartMessenger = (event) => {
    waitForIframeToExist('web-messenger-container').then(() => {
      waitForElementToExist('#messenger-button').then(element => {
        element.style.display = 'block';
      });

      let rdsn_chat_widget = document.getElementsByClassName("-rdsn-chat-widget");
      if (rdsn_chat_widget.length > 0) {
        rdsn_chat_widget[0].style.display = 'none';
      }

      document.getElementById("web-messenger-container").contentWindow.document.getElementById("messenger-button").click();

      waitForElementToExist('.close-handle').then(element => {
        waitForElementToExist('#messenger-button').then(element => {
          element.style.display = 'none';
        });
        let close_handle = document.getElementById("web-messenger-container").contentWindow.document.getElementsByClassName("close-handle");
        if (close_handle.length > 0) {
          close_handle[0].addEventListener('click', function (event) {
            showMessengerSetAfterClick();
          });
        }

        let chat_header = document.getElementById("web-messenger-container").contentWindow.document.getElementById("header");
        if (chat_header) {
          chat_header.addEventListener('click', function (event) {
            showMessengerSetAfterClick();
          });
        }
      });
    });
  }

  waitForElementToExist('#messenger-button').then(element => {
    document.getElementById("web-messenger-container").style.display = 'block';
    element.style.display = 'none';
  });


  document.getElementById("chat-widget-messenger-button").addEventListener('click', clickEventStartMessenger);

  const clickEventOpenIconSet = (event) => {
    let chat_widget = document.getElementById("rdsn-chat-widget_icon-list");
    if (chat_widget) {
      if (chat_widget.classList.contains('-rdsn-chat-widget__icon-list-show')) {
        chat_widget.classList.remove("-rdsn-chat-widget__icon-list-show");
      } else {
        chat_widget.classList.add("-rdsn-chat-widget__icon-list-show");
      }
    }
  }

  let start_widget_icon = document.getElementById("rdsn-start-chat-widget__icon");
  console.log('chat init');
  if (start_widget_icon) {
    start_widget_icon.addEventListener('click', clickEventOpenIconSet);
  }

  let close_widget_icon = document.getElementById("rdsn-close-chat-widget__icon");

  if (close_widget_icon) {
    close_widget_icon.addEventListener('click', clickEventOpenIconSet);
  }

}